<div matRipple class="card" [class.active]="selected()" [class.disabled]="disabled()" (click)="onCardClick()">
  <ng-content />
</div>

@if (selected()) {
  <div class="selection">
    <mat-icon color="primary">check_circle</mat-icon>
  </div>
}
